import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import React, { useState } from "react";
import JedaiTooltip from "../../../coms/JedaiTooltip";
import icon_ayuda from "../../../assets/img/icon_ayuda_verde_oscuro.svg";
import * as PropTypes from "prop-types";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

function ValorCobertura({ val }) {
    if (isNaN(val)) return val;
    return <ReactNumeric valuex={val} readOnly className="form-control-plaintext text-right" />;
}

ValorCobertura.propTypes = { val: PropTypes.any };
export const CoberturaGrupo = ({ grupo = "", coberturas = [] }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <>
            <div aria-multiselectable={true} className="card-collapse my-2">
                <Card className="card-plain my-0">
                    <CardHeader role="tab" className={`card-header-subcollapse ${open && "active"}`}>
                        <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                            {coberturas[0]?.grupo || grupo}&nbsp;&nbsp;
                            <i
                                className={
                                    !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                                }
                            />
                        </div>
                    </CardHeader>
                    <Collapse isOpen={open}>
                        <Container className="text-center pl-0">
                            <div className={"table-responsive border-top-0"}>
                                <Table className="adjusttd text-center">
                                    <thead className="text-primary">
                                        <tr>
                                            <th className="text-left">Item</th>
                                            <th className="text-left">Cobertura</th>
                                            <th className="text-right">Valor Límite</th>
                                            <th className="text-left">Unidad</th>
                                            <th className="text-left">Observaciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {coberturas.length === 0 ? (
                                            <React.Fragment>
                                                <tr>
                                                    <td colSpan={5}>
                                                        <span>No hay información disponible.</span>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {coberturas.map((item, index) => (
                                                    <tr key={item.cdCobNegocio}>
                                                        <td>
                                                            <span>{index + 1}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>{item.nmCobertura}</span>&nbsp;
                                                            {item?.ayuda && (
                                                                <JedaiTooltip placement={"bottom"} message={item.ayuda}>
                                                                    <img src={icon_ayuda} alt="" width={"20"} />
                                                                </JedaiTooltip>
                                                            )}
                                                        </td>
                                                        <td className="text-right">
                                                            <ValorCobertura val={item.valLimite} />
                                                        </td>
                                                        <td className="text-center">
                                                            <span>{item.dscRubro}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>{item.obsCobNegocio}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Container>
                    </Collapse>
                </Card>
            </div>
        </>
    );
};
